module.exports = __webpack_public_path__ + "static/media/group.e92bd25f.jpeg";